export default __webpack_public_path__ + "static/media/t4.044f2e9d.jpg";